import { render, staticRenderFns } from "./SplitList.pug?vue&type=template&id=804510c2&scoped=true&lang=pug&"
import script from "./SplitList.vue?vue&type=script&lang=js&"
export * from "./SplitList.vue?vue&type=script&lang=js&"
import style0 from "./SplitList.scss?vue&type=style&index=0&id=804510c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804510c2",
  null
  
)

export default component.exports